import React from "react";
import lungGraphic from "../assets/updated-image-03.jpg";
import SlimeticsGif from "../assets/Inflamed Gut GIF.gif";

const OverlookedFactor = () => {
  return (
    <div>
      <h2 className="text-2xl font-bold text-[#303030] mb-6">
        {
          "The Overlooked Factor Behind Weight Struggles—And Why It's Often Missed"
        }
      </h2>
      <div className="relative w-full mb-6">
        <img
          src={lungGraphic}
          alt="Overweight woman"
          className="w-full rounded-3xl border border-gray-100"
          draggable="false"
        />
      </div>
      <div className="space-y-4 text-[#303030]">
        <p className="font-bold">
          {
            "What if most weight-related struggles—bloating, cravings, stubborn fat—had less to do with willpower, and more to do with your internal gut balance?"
          }
        </p>
        <p>{" New studies suggest they might. "}</p>
        <p>
          The gut’s role in digesting food, absorbing nutrients, and regulating
          hormones is crucial. But with today’s highly processed foods,
          environmental stressors, and artificial additives, our gut microbiome
          is often under strain.
        </p>
        <p>
          Over time, this can lead to an inflamed, sluggish gut—making weight
          management significantly more difficult.
        </p>
      </div>
      <div className="my-5">
        <div data-v-7da0ed78="" data-eid="598799" className="element-wrapper">
          <div
            data-v-7da0ed78=""
            data-autoplay="true"
            data-lazyload="true"
            data-loop="true"
            data-muted="true"
            data-width="100%"
            className="video-native loaded playing"
            style={{
              width: "100%",
              margin: "20px 0px 0px",
            }}
          >
            {/* <video
              poster={breatheposter}  
              autoPlay
              loop
               muted
              playsInline
              disablePictureInPicture
              className="rounded-3xl"
              style={{
                aspectRatio: "1600 / 850",  
                objectPosition: "center center",
              }}
              src={breathevideo}  
            />   */}

            <img
              src={SlimeticsGif}
              alt="slimetics GIF"
              className="rounded-3xl w-full"
              style={{
                aspectRatio: "1600 / 850",
                objectPosition: "center center",
              }}
            />
          </div>
        </div>
        <div className="mt-6">
          <div className="space-y-4 text-[#303030]">
            <p className="font-bold">{"Here’s Why That Matters… "}</p>
            <p>
              {
                "Many everyday foods contain artificial preservatives, seed oils, and refined sugars that can throw off your gut’s natural balance."
              }
            </p>
            <p>
              {
                "When this happens, digestion slows, your energy dips, and your metabolism may begin to underperform."
              }
            </p>
            <p>
            At first, it might show up as bloating or fatigue. But over time, it may evolve into more persistent weight retention—despite healthy eating or exercise.
            </p>
            <p>
              {
                "This is why calorie counting, fasting, and intense workouts sometimes don’t work—they don’t support the root cause: the gut."
              }
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OverlookedFactor;
